import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { Outlet } from 'react-router-dom';

import { MyClubPageHeader } from '@sorare/core/src/components/navigation/MyClubPageHeader';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import type {
  MyClubSlugLayoutQuery,
  MyClubSlugLayoutQueryVariables,
} from './__generated__/index.graphql';

const MY_CLUB_SLUG_QUERY = gql`
  query MyClubSlugLayoutQuery($slug: String!) {
    user(slug: $slug) {
      slug
      nickname
      ...MyClubPageHeader_user
    }
  }
  ${MyClubPageHeader.fragments.user}
` as TypedDocumentNode<MyClubSlugLayoutQuery, MyClubSlugLayoutQueryVariables>;

export const loader = queryLoader<{ slug: string }>(
  MY_CLUB_SLUG_QUERY,
  ({ slug }) => ({
    slug,
  })
);

export const MyClubSlugLayout = () => {
  const { data } = useQueryLoader<MyClubSlugLayoutQuery>();
  return (
    <>
      <MyClubPageHeader user={data.user} />
      <Outlet />
    </>
  );
};
